import React from 'react';
import { Tooltip } from '@mui/material';
import EditCloneDeleteMenu from "../../Menus/EditCloneDeleteMenu";



export const UsageGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },
    {    field: 'id',
        headerName: 'ID',

        sortable: true,
        width: 60,
    },
    {    field: 'fileId',
        headerName: 'File ID',
        sortable: true,
        width: 180,
    },
    {
        field: 'externalId',
        headerName: 'External ID',

        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'propertyId',
        headerName: 'Property ID',
        sortable: true,
        width: 100,
    },
    {
        field: 'productName',
        headerName: 'Product Name',
        sortable: true,
        // editable: true,
        width: 300,
    },
    {
        field: 'episodeName',
        headerName: 'Episode Name',
        sortable: true,
        // editable: true,
        width: 250,
    },
    {
        field: 'seriesExternalId',
        headerName: 'Series ID',
        sortable: true,
        width: 80,

    },
    {
        field: 'seriesName',
        headerName: 'Series Name',
        sortable: true,
        width: 250,

    },

    {
        field: 'seasonExternalId',
        headerName: 'Season ID',
        sortable: true,
        // editable: true,
        width: 80,
    },
    {
        field: 'season',
        headerName: '#',
        sortable: true,
        // editable: true,
        width: 40,
    },
    {
        field: 'seasonName',
        headerName: 'Season Name',
        sortable: true,
        // editable: true,
        width: 250,
    },
    {
        field: 'useStart',
        headerName: 'Start',

        sortable: true,
        width: 250,
    },
    {
        field: 'useEnd',
        headerName: 'End',

        sortable: true,
        width: 250,
    },
    {
        field: 'language',
        headerName: 'Language',
        variant: "filled",
        sortable: true,
        width: 150,
    },


    {
        field: 'platformId',
        headerName: 'Platform ID',

        sortable: true,
        width: 150,
    },
    {
        field: 'platformName',
        headerName: 'Platform Name',

        sortable: true,
        width: 150,
    },
    {
        field: 'service',
        headerName: 'Service',

        sortable: true,
        width: 150,
    },
    {
        field: 'platformTerritory',
        headerName: 'Territory',

        sortable: true,
        width: 150,
    },
    {
        field: 'usageMarket',
        headerName: 'Usage Market',

        sortable: true,
        width: 150,
    },
    {
        field: 'platformOwner',
        headerName: 'Owner',

        sortable: true,
        width: 150,
    },
    {
        field: 'licenseId',
        headerName: 'License ID',

        sortable: true,
        width: 150,
    },
    {
        field: 'licensee',
        headerName: 'Licensee',

        sortable: true,
        width: 150,
    },
    {
        field: 'stakeholderId',
        headerName: 'Stakeholder ID',

        sortable: true,
        width: 150,
    },
    {
        field: 'status',
        headerName: 'Status',
        sortable: true,
        width: 150,
    },

];
